import React from 'react';
import { Tr } from './Tr';

export const StringOrTr = (props) => {
	if (typeof props.value === 'object') return <Tr tr={props.value} />;
	return props.value;
};
